var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.437 7.695 4.29 9.547 9.307 4.53 7.462 2.67 2.437 7.695ZM.742 11.242 3.637 10.2 1.792 8.37l-1.05 2.872ZM9.93.742c-.36 0-.69.15-.93.383l-1.08 1.08 1.852 1.852 1.08-1.08c.24-.24.383-.562.383-.93A1.301 1.301 0 0 0 9.93.742Z"
  })));
};
export default SvgPencil;